export enum CharacterDonationBySpenderSortEnum {
  USER_ID = 'USER_ID',
  USERNAME = 'USERNAME',
  COINS_SPEND = 'COINS_SPEND',
}
